<script>
	import Swal from "sweetalert2";

	async function showSuccessModal(message = "Sua requisição foi enviada.", title = "Sucesso") {
		return Swal({
			title,
			text: message,
			type: "success",
			confirmButtonClass: "md-button md-success",
			buttonsStyling: false,
			animation: false
		});
	}

	async function showFailModal(message = "Houve uma falha ao processar sua requisição", title = "Erro") {
		return Swal({
			title,
			text: message,
			type: 'error',
			confirmButtonClass: 'md-button md-danger',
			buttonsStyling: false,
			animation: false
		});
	}

	async function showConfirmationModal(text1 = 'Tem certeza?', text2 = 'Não é possível reverter a operação!') {
		return Swal({
			title: text1,
			text: text2,
			type: 'warning',
			animation: false,
			showCancelButton: true,
			confirmButtonText: 'Prosseguir',
			cancelButtonText: 'Cancelar',
			confirmButtonClass: 'md-button md-success',
			cancelButtonClass: 'md-button md-danger',
			buttonsStyling: false
		});
	}

	async function showReasonModal(text1 = 'Qual o motivo?', placeholder = "Digite aqui o motivo da ação") {
		return Swal({
			title: text1,
			input: 'text',
			animation: false,
			showCancelButton: true,
			confirmButtonText: 'Enviar',
			cancelButtonText: 'Cancelar',
			inputPlaceholder: placeholder,
			confirmButtonClass: 'md-button md-success',
			cancelButtonClass: 'md-button md-danger',
			buttonsStyling: false
		});
	}

	function executeAsync(asyncFunction, successMessage, errorMessage, errorHandler) {
		asyncFunction()
			.then(() => {
				if (successMessage) {
					return showSuccessModal(successMessage);
				}
			})
			.catch(error => {
				if (errorHandler) {
					return errorHandler(error);
				}

				if (error.error === "ERR_BAD_REQUEST" && error.errorDetails) {
					return showFailModal(`Erro de validação: ${error.errorDetails}`);
				}

				switch(error.message) {
					case "MISSING_FIELDS":
						return showFailModal("Preencha os campos obrigatórios");
					case "CANCELLED":
						return showFailModal("A requisição foi cancelada", "Cancelado");
					case "NOT_ALLOWED":
						return showFailModal("Operação não permitida");
				}

				console.error(error);

				if (errorMessage) {
					return showFailModal(errorMessage);
				}
			});
	}

	async function readFileAsText(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = (event) => resolve(event.target.result);
			reader.onabort = () => reject(Error("ERR_FILE_READ"));
			reader.onerror = () => reader.abort();

			reader.readAsText(file);
		});
	}

	export default {
		showSuccessModal,
		showFailModal,
		showConfirmationModal,
		executeAsync,
		readFileAsText,
		showReasonModal,
	}
</script>

<style>
	.swal2-container {
		z-index: 9999 !important;
	}
</style>
